var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "side-menu-wrapper", style: { zIndex: _vm.zIndex } },
    [
      _vm.overlay
        ? _c("transition", { attrs: { name: "fade" } }, [
            _vm.open
              ? _c("div", {
                  staticClass: "side-menu-overlay",
                  style: { background: _vm.overlay }
                })
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: _vm.position } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.open,
                expression: "open"
              }
            ],
            ref: "target",
            staticClass: "side-menu",
            class: {
              "off-canvas": _vm.behavior === "push",
              "pos-top": _vm.position === "top",
              "pos-right": _vm.position === "right"
            },
            style: {
              background: _vm.background,
              "max-width": _vm.maxWidth
            }
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }